/**
 * A helper class for working with cookies.
 */
export class CookieHelper {
  /**
   * Retrieves the value of a cookie by name.
   * @param name - The name of the cookie.
   * @returns The value of the cookie. If the cookie does not exist, it returns undefined.
   */
  static get(name: string): string | undefined {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => this.compareValues(row, name))
      ?.split('=')[1];
    return cookieValue;
  }

  /**
   * Compares two values in a case-insensitive manner.
   * @param value1 - The first value to compare.
   * @param value2 - The second value to compare.
   * @returns True if the values are equal, false otherwise.
   */
  static compareValues(value1: string, value2: string): boolean {
    value1 = value1?.toLowerCase();
    value2 = value2?.toLowerCase();
    const result = value1.startsWith(value2) || value1.toLowerCase().includes(value2);
    return result;
  }

  /**
   * Retrieves a boolean value from a cookie.
   * @param name - The name of the cookie.
   * @returns The boolean value stored in the cookie. If the cookie does not exist or the value is not a valid boolean, it returns false.
   */
  static getBool(name: string): boolean {
    const cookieValue = this.get(name);
    const value = cookieValue?.toLowerCase() == 'true';
    return value;
  }

  /**
   * Sets the expiry for a cookie.
   * @param cookieName - The name of the cookie.
   * @param expiry - The expiry time in days.
   */
  static setExpiry(cookieName: string, expiry: number): void {
    const date = new Date();
    date.setTime(date.getTime() + expiry * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${cookieName}=True; ${expires}; path=/`;
  }
}
